import dayjs from "dayjs";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { yupLocalized } from "@ryde/shared";

import { BulkActivateShiftTemplateFormFieldsEnum } from "../models";

export const useBulkActivateShiftTemplateValidation = () => {
  const { t } = useTranslation();

  const validation = useMemo(() => {
    const startDateLabel = t(
      `passenger.formLabel.${BulkActivateShiftTemplateFormFieldsEnum.startDate}`,
    );

    return {
      [BulkActivateShiftTemplateFormFieldsEnum.startDate]: yupLocalized
        .string()
        .required(t("validation.required", { path: startDateLabel }))
        .test(
          "min-tomorrow",
          t("general.ACTIVATE_SHIFT_TEMPLATE_START_DATE_FUTURE"),
          value => {
            if (!value) {
              return true;
            }
            const tomorrow = dayjs().add(1, "day").startOf("day");
            return !dayjs(value).startOf("day").isBefore(tomorrow);
          },
        ),
    };
  }, [t]);

  return { validation };
};
